import { createFileRoute } from "@tanstack/react-router";
import { RecycleBinPage } from "@client/components/recycle-bin/recycle-bin-page";

export const Route = createFileRoute("/_app/recycle-bin")({
  component: RecycleBin,
});

function RecycleBin() {
  return <RecycleBinPage />;
}
